import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ResetPasswordForm from '../../components/auth/ResetPasswordForm';
import Image from '../../components/common/Image';
import { TaskyAlert, TaskyAuthLayout } from '../../components/tasky';

const ResetPasswordPage: React.FC = () => {
  const [token, setToken] = useState('');
  const [email, setEmail] = useState('');
  const [isValid, setIsValid] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenParam = params.get('token');
    const emailParam = params.get('email');
    if (tokenParam && emailParam) {
      setToken(tokenParam);
      setEmail(emailParam);
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [location]);

  return (
    <TaskyAuthLayout
      logo={<Image category="common" fileName="logo.png" alt="ロゴ" className="h-10 w-auto" />}
      footer={
        <Link
          to="/login"
          className="inline-flex items-center gap-1 text-sm text-primary hover:text-primary-hover font-medium transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          ログイン画面に戻る
        </Link>
      }
    >
      {isValid ? (
        <ResetPasswordForm token={token} email={email} />
      ) : (
        <TaskyAlert tone="error" title="無効または期限切れのリンクです">
          新しいリセットリンクを申請してください。
        </TaskyAlert>
      )}
    </TaskyAuthLayout>
  );
};

export default ResetPasswordPage;
